import { css, SimpleInterpolation } from 'styled-components';

export const checkerboard = (color1: SimpleInterpolation, color2: SimpleInterpolation = 'transparent', size = 15) => css`
  background-color: ${color2};
  background-image: linear-gradient(45deg, ${color1} 25%, transparent 25%), linear-gradient(-45deg, ${color1} 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, ${color1} 75%), linear-gradient(-45deg, transparent 75%, ${color1} 75%);
  background-size: ${size}px ${size}px;
  background-position: 0 0, 0 ${size / 2}px, ${size / 2}px -${size / 2}px, -${size / 2}px 0px;
`;
